import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createWalletActionByCustomerReferenceRequest = {
    walletAction: '_walletAction',
};
var _createWalletActionByCustomerReferenceResponse = {
    walletAction: '_walletAction',
};
var _createWalletActionRequest = { walletAction: '_walletAction' };
var _createWalletActionResponse = { walletAction: '_walletAction' };
var _deleteWalletActionRequest = {};
var _deleteWalletActionResponse = {};
var _disableWalletActionRequest = {};
var _disableWalletActionResponse = { walletAction: '_walletAction' };
var _getWalletActionRequest = {};
var _getWalletActionResponse = { walletAction: '_walletAction' };
var _queryWalletActionBalancesRequest = {};
var _queryWalletActionBalancesResponse = {
    walletActions: '_walletActionWithBalance',
};
var _queryWalletActionRequest = {};
var _queryWalletActionResponse = { walletActions: '_walletAction' };
var _updateWalletActionRequest = {
    mask: 'google.protobuf.FieldMask',
    walletAction: '_walletAction',
};
var _updateWalletActionResponse = { walletAction: '_walletAction' };
var _walletAction = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    startDate: 'google.protobuf.Timestamp',
    expirationDate: 'google.protobuf.Timestamp',
    disableDate: 'google.protobuf.Timestamp',
    walletActionStarted: '_walletActionExecutionDetails',
    walletActionEnded: '_walletActionExecutionDetails',
};
var _walletActionExecutionDetails = {
    executionDate: 'google.protobuf.Timestamp',
};
var _walletActionWithBalance = { walletAction: '_walletAction' };
function resolveWixRiseV1WalletActionServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wallet-action-service',
                destPath: '/v1/rise',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/wallet-action-service',
                destPath: '/v1/rise',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/wallet-action-service',
                destPath: '/v1/rise',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/wallet-action-service',
                destPath: '/v1/rise',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wallet-action-service',
                destPath: '/v1/rise',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/wallet-action-service',
                destPath: '/v1/rise',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wallet-action-service',
                destPath: '/v1/rise',
            },
        ],
        'platform.rise.ai': [
            {
                srcPath: '/v1/rise/wallet_actions',
                destPath: '/v1/rise/wallet_actions',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new WalletAction */
export function createWalletAction(payload) {
    var _a = serializer(_createWalletActionRequest, { _walletAction: _walletAction, _walletActionExecutionDetails: _walletActionExecutionDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createWalletActionResponse, {
        _walletAction: _walletAction,
        _walletActionExecutionDetails: _walletActionExecutionDetails,
    }).fromJSON;
    function __createWalletAction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet_action',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletActionService.CreateWalletAction',
            url: resolveWixRiseV1WalletActionServiceUrl({
                protoPath: '/v1/rise/wallet_actions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createWalletAction.fromReq = fromReq;
    __createWalletAction.__isAmbassador = true;
    return __createWalletAction;
}
export function createWalletActionByCustomerReference(payload) {
    var _a = serializer(_createWalletActionByCustomerReferenceRequest, { _walletAction: _walletAction, _walletActionExecutionDetails: _walletActionExecutionDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createWalletActionByCustomerReferenceResponse, { _walletAction: _walletAction, _walletActionExecutionDetails: _walletActionExecutionDetails }).fromJSON;
    function __createWalletActionByCustomerReference(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet_action',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletActionService.CreateWalletActionByCustomerReference',
            url: resolveWixRiseV1WalletActionServiceUrl({
                protoPath: '/v1/rise/wallet_actions/by_customer_reference',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createWalletActionByCustomerReference.fromReq = fromReq;
    __createWalletActionByCustomerReference.__isAmbassador = true;
    return __createWalletActionByCustomerReference;
}
/** Get an WalletAction by ID */
export function getWalletAction(payload) {
    var _a = serializer(_getWalletActionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWalletActionResponse, {
        _walletAction: _walletAction,
        _walletActionExecutionDetails: _walletActionExecutionDetails,
    }).fromJSON;
    function __getWalletAction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet_action',
            method: 'GET',
            methodFqn: 'wix.rise.v1.WalletActionService.GetWalletAction',
            url: resolveWixRiseV1WalletActionServiceUrl({
                protoPath: '/v1/rise/wallet_actions/{walletActionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWalletAction.fromReq = fromReq;
    __getWalletAction.__isAmbassador = true;
    return __getWalletAction;
}
/**
 * Update an WalletAction, supports partial update
 * Pass the latest `revision` for a successful update
 */
export function updateWalletAction(payload) {
    var _a = serializer(_updateWalletActionRequest, { _walletAction: _walletAction, _walletActionExecutionDetails: _walletActionExecutionDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateWalletActionResponse, {
        _walletAction: _walletAction,
        _walletActionExecutionDetails: _walletActionExecutionDetails,
    }).fromJSON;
    function __updateWalletAction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet_action',
            method: 'PATCH',
            methodFqn: 'wix.rise.v1.WalletActionService.UpdateWalletAction',
            url: resolveWixRiseV1WalletActionServiceUrl({
                protoPath: '/v1/rise/wallet_actions/{walletAction.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateWalletAction.fromReq = fromReq;
    __updateWalletAction.__isAmbassador = true;
    return __updateWalletAction;
}
/** Expire an WalletAction immediately and deducting the remaining balance from the gift card */
export function disableWalletAction(payload) {
    var _a = serializer(_disableWalletActionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disableWalletActionResponse, {
        _walletAction: _walletAction,
        _walletActionExecutionDetails: _walletActionExecutionDetails,
    }).fromJSON;
    function __disableWalletAction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet_action',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletActionService.DisableWalletAction',
            url: resolveWixRiseV1WalletActionServiceUrl({
                protoPath: '/v1/rise/wallet_actions/{walletActionId}/disable',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disableWalletAction.fromReq = fromReq;
    __disableWalletAction.__isAmbassador = true;
    return __disableWalletAction;
}
/** Delete an WalletAction, only available for wallet_actions which haven't started */
export function deleteWalletAction(payload) {
    var _a = serializer(_deleteWalletActionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteWalletActionResponse, {}).fromJSON;
    function __deleteWalletAction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet_action',
            method: 'DELETE',
            methodFqn: 'wix.rise.v1.WalletActionService.DeleteWalletAction',
            url: resolveWixRiseV1WalletActionServiceUrl({
                protoPath: '/v1/rise/wallet_actions/{walletActionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteWalletAction.fromReq = fromReq;
    __deleteWalletAction.__isAmbassador = true;
    return __deleteWalletAction;
}
/** Query WalletActions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryWalletActions(payload) {
    var _a = serializer(_queryWalletActionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryWalletActionResponse, {
        _walletAction: _walletAction,
        _walletActionExecutionDetails: _walletActionExecutionDetails,
    }).fromJSON;
    function __queryWalletActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet_action',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletActionService.QueryWalletActions',
            url: resolveWixRiseV1WalletActionServiceUrl({
                protoPath: '/v1/rise/wallet_actions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryWalletActions.fromReq = fromReq;
    __queryWalletActions.__isAmbassador = true;
    return __queryWalletActions;
}
/**
 * Query WalletActions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
 * Results will be enriched with calculated balances
 */
export function queryWalletActionsBalances(payload) {
    var _a = serializer(_queryWalletActionBalancesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryWalletActionBalancesResponse, {
        _walletAction: _walletAction,
        _walletActionExecutionDetails: _walletActionExecutionDetails,
        _walletActionWithBalance: _walletActionWithBalance,
    }).fromJSON;
    function __queryWalletActionsBalances(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.v1.wallet_action',
            method: 'POST',
            methodFqn: 'wix.rise.v1.WalletActionService.QueryWalletActionsBalances',
            url: resolveWixRiseV1WalletActionServiceUrl({
                protoPath: '/v1/rise/wallet_actions/query/balances',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryWalletActionsBalances.fromReq = fromReq;
    __queryWalletActionsBalances.__isAmbassador = true;
    return __queryWalletActionsBalances;
}
//# sourceMappingURL=http.impl.js.map